import {fetchDelete, fetchGet, fetchPatch, fetchPost} from "./util";

// GET: Fetch caterers list with pagination, filtering, and sorting
export const getCaterers = (results, columns, pageIndex, query, sort, viewArchived) => {
    return fetchGet(`/caterers?results=${results}&columns=${columns}&viewArchived=${viewArchived}&offset=${pageIndex + 1}${query}${sort}`).then(res => res);
};

// GET: Fetch single caterer by ID
export const getCatererById = (catererId) => {
    return fetchGet(`/caterers/${catererId}`).then(res => res);
};

// POST: Create new caterer
export const createCaterer = (data) => {
    return fetchPost(`/caterers`, data).then(res => res);
};

// DELETE: Delete a caterer by ID
export const deleteCaterer = (catererId) => {
    return fetchDelete(`/caterers/${catererId}`).then(res => res);
};

// PATCH: Update caterer details
export const updateCaterer = (catererId, data) => {
    return fetchPatch(`/caterers/${catererId}`, data).then(res => res);
};

// GET: Archive a caterer
export const archiveCaterer = (catererId) => {
    return fetchPatch(`/caterers/${catererId}/archive`).then(res => res);
};

// GET: Restore a caterer
export const restoreCaterer = (catererId) => {
    return fetchPatch(`/caterers/${catererId}/restore`).then(res => res);
};

// GET: Fetch all caterers
export const getActiveCaterers = async () => {
    return fetchGet(`/caterers/active`).then(res => res);
};